import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

// Services
import { mySettingsEdit, mySettingsGet } from '../../services/user';

// Components
import Icon from '../../components/Icon';
import List, {
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader
} from '../../components/List';
import Switch from '../../components/Switch';

// Component
interface IProps {}

class MeDialogSettings extends React.Component<IProps> {
  @observable pushNotifications = false;
  @observable emailNotification = false;

  componentDidMount() {
    this.getSettings();
  }

  async getSettings() {
    const res = await mySettingsGet();
    this.pushNotifications = res.pushNotification;
    this.emailNotification = res.emailNotification;
  }

  handlePushToggle = async (e: React.ChangeEvent<{}>, checked: boolean) => {
    await mySettingsEdit({
      body: {
        pushNotification: checked,
        emailNotification: this.emailNotification
      }
    });
    this.pushNotifications = checked;
  };

  handleEmailToggle = async (e: React.ChangeEvent<{}>, checked: boolean) => {
    await mySettingsEdit({
      body: {
        pushNotification: this.pushNotifications,
        emailNotification: checked
      }
    });
    this.emailNotification = checked;
  };

  render() {
    return (
      <List subheader={<ListSubheader>Settings</ListSubheader>}>
        <ListItem>
          <ListItemIcon>
            <Icon>smartphone</Icon>
          </ListItemIcon>
          <ListItemText primary="Mobile Notification" />
          <ListItemSecondaryAction>
            <Switch
              onChange={this.handlePushToggle}
              checked={this.pushNotifications}
            />
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon>email</Icon>
          </ListItemIcon>
          <ListItemText primary="Email Notification" />
          <ListItemSecondaryAction>
            <Switch
              onChange={this.handleEmailToggle}
              checked={this.emailNotification}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    );
  }
}

export default observer(MeDialogSettings);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/MeDialogSettings.tsx